import React from 'react'
import SwiperCore from 'swiper';
import { Autoplay, Keyboard, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import '../../assets/testimonial.css'
import FiveStars from "../../assets/icons/five-stars.svg"
import 'swiper/css';

const isBrowser = typeof window !== 'undefined';

const TestimonialScroller = ({ testimonials, data }) => {
    const { button } = data

    let perPage = 2;

    if (isBrowser) {
        if (window.innerWidth < 1000) {
            perPage = 1;
        } 
    }

    SwiperCore.use([Autoplay, Keyboard, Navigation]);

    return (
        <section className="testimonial-scroller">
            <Swiper
                slidesPerView={perPage}
                slidesPerGroup={1}
                speed={1000}
                loop={true}
                spaceBetween={50}
                height={460}
                autoplay={{ delay: 6000 }}
                keyboard={{ enabled: true }}
                navigation={{
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                }}
                direction={'vertical'}
                breakpoints={{
                  // when window width is >= 640px
                  640: {
                      slidesPerView: 2,
                      spaceBetween: 10,
                  },
                  // when window width is <= 639px
                  639: {
                      slidesPerView: 1,
                      spaceBetween: 30,
                  },
              }}
            >
                <a className="swiper-button-prev"></a>
                <a className="swiper-button-next"></a>
               { testimonials ? testimonials.map((slide, index) => (
                   <SwiperSlide key={index}>
                       <div className="testimonial-text testimonial-item">
                            <div className="rating">
                                <img alt="" src={ FiveStars } />
                            </div>
                            <p>{ slide.testimonial.testimonial }</p>
                            <p className="author">-{ slide.testimonial.author }</p>
                        </div>
                   </SwiperSlide>
               )) : ''} 
            </Swiper>
            {button && (
                <div className="testimonial-btn">
                    <a className="btn button-solid" href={button.url} target="_blank">{button.title}</a>
                </div>
            )}
        </section>
    )
}

export default TestimonialScroller